import {
  Box,
  Button,
  HStack,
  Input,
  InputGroup,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Stack,
  Text,
  VStack,
  chakra,
} from "@chakra-ui/react";
import { useContext, useMemo } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  KYDGuestlistDisplayState,
  KYDPixelSettings,
} from "@common/interfaces/KYDEvent";
import { KYDUserWithGuestlist } from "../../../../actions";
import { createDialogContext, DialogProvider } from "../../../../Common/Dialog";

export const PixelsAddEditDialogContext = createDialogContext();

const types = [
  {
    value: "facebook",
    text: "Meta",
  },
  {
    value: "tiktok",
    text: "TikTok",
  },
  {
    value: "twitter",
    text: "Twitter",
  },
  {
    value: "hive",
    text: "Hive",
  },
  {
    value: "ga",
    text: "Google Tag",
  },
];

const PixelsAddEditDialog = ({
  onSave,
  onClose,
  pixel,
  isLoading = false,
  creatingLoading,
  isEdit = false,
}: {
  isLoading: boolean;
  isEdit?: boolean;
  pixel: KYDPixelSettings;
  onClose: () => void;
  onSave: (data: {}, mode: "create" | "edit") => Promise<void>;
  creatingLoading: boolean;
}) => {
  const { isOpen } = useContext(PixelsAddEditDialogContext);

  console.log({
    pixel,
  });
  const {
    control,
    register,
    handleSubmit,
    reset,
    watch,
    formState: { isValid, errors },
  } = useForm({
    mode: "onChange",
    criteriaMode: "all",
    reValidateMode: "onChange",
    values: {
      id: pixel?.id,
      type: pixel?.type || "facebook",
    },
  });

  const _onClose = () => {
    reset();
    onClose();
  };

  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={_onClose}
        isCentered
      >
        <ModalOverlay />
        <ModalContent
          mb={[0, "auto"]}
          borderBottomLeftRadius={[0, "md"]}
          borderBottomRightRadius={[0, "md"]}
        >
          <ModalHeader paddingTop={4}>
            <VStack gap={0} width={"full"}>
              <Text w="full">
                {isEdit
                  ? `Edit ${pixel?.type} ${pixel.ad_account_id}`
                  : "Create new pixel"}
              </Text>
            </VStack>
          </ModalHeader>
          <ModalBody textAlign={"left"}>
            <VStack w="full">
              {/* <Text w="full">Hello</Text> */}
              <VStack spacing={4} gap={0} w="full">
                <Text w="full">Type</Text>
                <Select {...register(`type`)} isDisabled={isEdit}>
                  {types.map((pixelType) => (
                    <option key={pixelType.value} value={pixelType.value}>
                      {pixelType.text}
                    </option>
                  ))}
                </Select>
              </VStack>
              <VStack spacing={4} gap={0} w="full">
                <Text w="full">Account Id</Text>
                <Input type="text" {...register("id")} />
              </VStack>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Stack direction={["column-reverse", "row-reverse"]} width="100%">
              <Button
                key={"cancel"}
                isLoading={isLoading}
                isDisabled={isLoading}
                w={"auto"}
                onClick={_onClose}
              >
                Cancel
              </Button>
              <Button
                key={"submit"}
                variant="kydDark"
                w={"auto"}
                isLoading={isLoading}
                isDisabled={isLoading || !isValid}
                onClick={handleSubmit((data) =>
                  onSave(data, isEdit ? "edit" : "create")
                )}
              >
                Save
              </Button>
            </Stack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export const withPixelsAddEditDialog =
  <T extends object>(Component: React.ComponentType<T>) =>
  (props: T) => {
    return (
      <DialogProvider context={PixelsAddEditDialogContext}>
        <Component {...(props as T)} />
      </DialogProvider>
    );
  };

export default PixelsAddEditDialog;
